import { useState } from "react";
import useAxiosInstance from "../../hooks/useAxiosInstance";
import { useIconStyles } from "../../components/Helpers/iconStyles";
import { useDispatch, useSelector } from "react-redux";
import {
  API_RESULT,
  API_VERSION,
  PAYMENT_CREDIT_STATUS,
} from "../../enums/common.enum";
import { setAllSupplierPurchase } from "../../store/actions/useActions";
import { errorToast, handleError } from "../../utils/common";
import {
  Box,
  CircularProgress,
  IconButton,
  Stack,
  Tooltip,
} from "@mui/material";
import NotAllowedIcon from "@mui/icons-material/Block";
import RepeatIcon from "@mui/icons-material/Autorenew";
import CheckIcon from "@mui/icons-material/Check";
import RupeeIcon from "@mui/icons-material/CurrencyRupee";
import { PurchaseDetails } from "./purchaseDetails";
import MakePaymentModal from "./makePaymentModal";

const SupplierPaymentButton = ({
  activePurchase,
  activePayoutId,
  index,
}: any) => {
  const privateInstance = useAxiosInstance();
  // const [loading, setLoading] = useState(false);
  const [refreshLoading, setRefreshLoading] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [purchaseData, setPurchaseData] = useState<any>([]);
  const [showSinglePurchaseDetail, setShowSinglePurchaseDetail] =
    useState(false);
  const [activeInvId, setActiveInvId] = useState("");
  const iconClasses = useIconStyles();

  const dispatch = useDispatch();
  let invoiceToManage = useSelector(
    (state: any) => state.supplier.allPurchaseData
  );

  const purchaseDataParent = invoiceToManage?.find(
    (x: any) => x.purchase_id === activePurchase
  );

  const getSinglePurchaseData = async (type: string) => {
    try {
      const result = await privateInstance.get(
        `${API_VERSION.V3}/suppliers/purchases?purchase_id=${activePurchase}`
      );
      if (result?.data?.status === API_RESULT.SUCCESS) {
        setPurchaseData(result.data.response);
        if (type == "make_payment") {
          setPaymentModal(true);
        } else {
          const updated_item = result.data.response;
          invoiceToManage.splice(index, 1, updated_item);
          dispatch(setAllSupplierPurchase(invoiceToManage));
        }
      } else {
        errorToast(result.data.message);
      }
    } catch (err) {
      handleError(err);
    } finally {
      setRefreshLoading(false);
    }
  };

  const refreshStatus = async () => {
    setRefreshLoading(true);
    try {
      const result = await privateInstance.get(
        `${API_VERSION.V1}/orders/payments/status?payout_id=${activePayoutId}`
      );
      if (result?.data?.status === API_RESULT.SUCCESS) {
        getSinglePurchaseData("refresh_payment");
      } else {
        errorToast(result.data.message);
      }
    } catch (err) {
      handleError(err);
    }
  };

  const paymentCreditStatus =
    purchaseDataParent?.payment_credit_status?.toLowerCase();

  return (
    <Box>
      {paymentCreditStatus === "paid" ? (
        <Tooltip title="Payment Completed">
          <span>
            <IconButton
              color="success"
              onClick={() => {
                setActiveInvId(activePurchase);
                setShowSinglePurchaseDetail(true);
              }}
            >
              <CheckIcon className={iconClasses.borderedIcon} />
            </IconButton>
          </span>
        </Tooltip>
      ) : paymentCreditStatus === "failed" ? (
        <Tooltip title="Retry Payment">
          <span>
            <IconButton
              color="error"
              onClick={() => {
                getSinglePurchaseData("make_payment");
              }}
            >
              <NotAllowedIcon className={iconClasses.borderedIcon} />
            </IconButton>
          </span>
        </Tooltip>
      ) : paymentCreditStatus === "processing" ? (
        <Stack>
          {refreshLoading ? (
            <CircularProgress size={20} color="warning" />
          ) : (
            <Tooltip title="Refresh Payment">
              <span>
                <IconButton
                  color="warning"
                  onClick={() => {
                    refreshStatus();
                  }}
                >
                  <RepeatIcon className={iconClasses.borderedIcon} />
                </IconButton>
              </span>
            </Tooltip>
          )}
        </Stack>
      ) : paymentCreditStatus === "pending" ? (
        <Tooltip title="Make Payment">
          <span>
            <IconButton
              color="primary"
              onClick={() => {
                getSinglePurchaseData("make_payment");
              }}
            >
              <RupeeIcon className={iconClasses.borderedIcon} />
            </IconButton>
          </span>
        </Tooltip>
      ) : null}
      {showSinglePurchaseDetail && (
        <PurchaseDetails
          open={showSinglePurchaseDetail}
          handleClose={() => setShowSinglePurchaseDetail(false)}
          activeInvId={activeInvId}
        />
      )}
      {paymentModal && (
        <MakePaymentModal
          purchaseData={purchaseData}
          paymentModal={paymentModal}
          setPaymentModal={setPaymentModal}
        />
      )}
    </Box>
  );
};

export default SupplierPaymentButton;
